import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';


export const accessibilityStringifyDates = (eventFromDate, eventToDate, until = 'until', to = 'to', at = 'at') => {

    const isTimeIncluded = (date) => {
        return moment(date).hours() !== 0 || moment(date).minutes() !== 0;
    };

    const fromDateFormatted = moment(eventFromDate).format('dddd, MMMM Do');
    const fromTimeFormatted = isTimeIncluded(eventFromDate) ? moment(eventFromDate).format('h:mm A') : null;

    if (eventToDate) {
        const toTimeFormatted = isTimeIncluded(eventToDate) ? moment(eventToDate).format('h:mm A') : null;
        const timeDifference = moment(eventToDate).diff(eventFromDate, 'minutes');
        const conjunction = timeDifference > 60 ? until : to;

        const sameDay = moment(eventFromDate).isSame(eventToDate, 'day');
        if (sameDay) {
            return fromTimeFormatted
                ? `${fromDateFormatted} ${at} ${fromTimeFormatted}, ${conjunction} ${toTimeFormatted}`
                : fromDateFormatted;
        } else {
            const toDateFormatted = moment(eventToDate).format('dddd, MMMM Do');
            return fromTimeFormatted
                ? `${fromDateFormatted} ${at} ${fromTimeFormatted}, ${conjunction} ${toDateFormatted} ${at} ${toTimeFormatted}`
                : `${fromDateFormatted}, ${conjunction} ${toDateFormatted}`;
        }
    } else {
        return fromTimeFormatted ? `${fromDateFormatted} ${at} ${fromTimeFormatted}` : fromDateFormatted;
    }
};

accessibilityStringifyDates.propTypes = window.config.developMode ? {
    eventFromDate: PropTypes.string.isRequired,
} : {};

export const accessibilitySetPageLang = (lang = 'he') => {
    if (document.documentElement.lang != lang) {
        document.documentElement.lang = lang;
    }
}

export const accessibilityUpdatePageTitle = (title) => {
    if (title) {
        document.title = `${document.title} | ${title}`;
    }
}

export const accessibilityEnhanceHistory = () => {
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    history.pushState = function (...args) {
        const result = originalPushState.apply(this, args);
        window.dispatchEvent(new Event('pushState'));
        return result;
    };

    history.replaceState = function (...args) {
        const result = originalReplaceState.apply(this, args);
        window.dispatchEvent(new Event('replaceState'));
        return result;
    };
};
